import { useState } from "react";
import { Button } from "../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { MainLayout } from "../components/layout";

export function ApiTest() {
  const [result, setResult] = useState<string>("");
  const [loading, setLoading] = useState<string>("");

  const testEndpoint = async (name: string, url: string) => {
    setLoading(name);
    setResult("");
    try {
      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      setResult(JSON.stringify({ status: response.status, data }, null, 2));
    } catch (error: any) {
      setResult(JSON.stringify({ error: error.message }, null, 2));
    } finally {
      setLoading("");
    }
  };

  const tests = [
    {
      name: "Health Check",
      url: "http://localhost:8787/health",
    },
    {
      name: "API Info",
      url: "http://localhost:8787/api/v1",
    },
    {
      name: "Departments",
      url: "http://localhost:8787/api/v1/departments",
    },
    {
      name: "Auth Check",
      url: "http://localhost:8787/api/v1/auth/check",
    },
    {
      name: "Get Current User",
      url: "http://localhost:8787/api/v1/auth/me",
    },
  ];

  return (
    <MainLayout title="API Test">
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle>API Test Page</CardTitle>
            <CardDescription>
              Test API endpoints to verify connectivity and CORS
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              {tests.map((test) => (
                <Button
                  key={test.name}
                  onClick={() => testEndpoint(test.name, test.url)}
                  disabled={loading === test.name}
                  variant="outline"
                  className="w-full"
                >
                  {loading === test.name ? "Testing..." : test.name}
                </Button>
              ))}
            </div>

            {result && (
              <div className="mt-6">
                <h3 className="text-sm font-semibold mb-2">Result:</h3>
                <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-auto text-xs max-h-96">
                  {result}
                </pre>
              </div>
            )}

            <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-950/50 border border-blue-200 dark:border-blue-900 rounded-md">
              <h3 className="font-semibold text-blue-900 dark:text-blue-100 mb-2">
                Instructions:
              </h3>
              <ul className="list-disc list-inside text-sm text-blue-800 dark:text-blue-200 space-y-1">
                <li>
                  Make sure API server is running:{" "}
                  <code className="bg-blue-100 dark:bg-blue-900/50 px-1 rounded">
                    cd apps/api && pnpm dev
                  </code>
                </li>
                <li>Check browser console for CORS errors</li>
                <li>
                  Verify API is listening on{" "}
                  <code className="bg-blue-100 dark:bg-blue-900/50 px-1 rounded">
                    http://localhost:8787
                  </code>
                </li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
}

export default ApiTest;
